/**
 *
 * Asynchronously loads the component for UserPortfoliosPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const UserPortfoliosPage = lazyLoad(
  () => import('./index'),
  module => module.UserPortfoliosPage,
);
